(function () {

  /**
   *  Initialize the save/unsaved buttons displayed in the next steps redesigned section
   */
  var initSaveToFavorites = function () {
    var nextStepsSaveButton = document.querySelector("[data-favorites-save]");
    var gallerySaveButton = document.querySelector("#gallery .nhs_favUnsave");
    var saveToFavoritesLoginButton = document.querySelector("#gallery .nhs_favLogin");
    if (nextStepsSaveButton !== null) {
      nextStepsSaveButton.addEventListener("click", function () {
        if (saveToFavoritesLoginButton && !saveToFavoritesLoginButton.classList.contains("nhs_favLogin")) {
          saveToFavoritesLoginButton.click();
        } else if (!gallerySaveButton.classList.contains("nhs_favLogin")) {
          gallerySaveButton.click();
        }

      });
    }
    var nextStepsUnsaveButton = document.querySelector("[data-favorites-unsave]");
    var galleryUnsaveButton = document.querySelector("#gallery .nhs_favSaved");
    if (nextStepsUnsaveButton !== null) {
      nextStepsUnsaveButton.addEventListener("click", function () {
        galleryUnsaveButton.click();
      });
    }
  }

  //Events to Track Google Analytics, uses the ga function declared globally by Analytics.js
  var bindGoogleAnalyticsEvents = function () {
    document.addEventListener("click", function (event) {
      var eventCategory = "Gallery Detail Pages";
      var eventAction = null;
      var id = null;
      var eventLabel = null;

      if (!event.target || "function" !== typeof ga || (ga && "function" !== typeof ga.getAll)) {
        return;
      }

      var allGa = ga.getAll().filter(function (element) {
        return element.get("trackingId") === "UA-40843711-4";
      });

      if (allGa[0]) {
        id = allGa[0].get("name");
      }

      if (event.target.classList.value === "media-tabs__icon") {
        event.target.id = event.target.parentElement.id;
      }

      if ("img" === event.target.nodeName.toLowerCase() && event.target.getAttribute('data-full-image-viewer-opener') === 'true' && event.target.classList && event.target.classList.contains("active")) {
        eventAction = "FWIV open - image click";
        eventLabel = "Image click to open FWIV";
      }

      if ("nhs_GalleryPrev" === event.target.id) {
        eventAction = "On-page Gallery forward-back";
        eventLabel = "Back";
      }

      if ("nhs_GalleryNext" === event.target.id) {
        eventAction = "On-page Gallery forward-back";
        eventLabel = "Forward";
      }

      if (event.target.classList.contains("nhs_Close")) {
        eventAction = "Gallery Navigation";
        eventLabel = "Close button clicks";
      }

      //Additional Details Label
      if ("nhs_additionalDetailsLabel" === event.target.id) {
        eventCategory = "Detail Page Events";
        eventAction = "Clicks to additional com details";
        eventLabel = "Additional com details";
      }

      //Add to NHS App - From Map
      if ("nhs_addToNhsAppOnMap" === event.target.id) {
        eventCategory = "Detail Page Events";
        eventAction = "Misc Click Events";
        eventLabel = "Add to NHS App - from map area";
      }

      //Tabs on Map Section
      if ("object" === typeof event.target.dataset && event.target.dataset.isMapDirectionsTab) {
        var tabsElements = document.querySelectorAll("[data-is-map-directions-tab]");
        if (tabsElements && tabsElements.length > 1) {
          eventCategory = "Detail Page Events";
          eventAction = "Insert Map Navigation";
          eventLabel = "Tab click - " + event.target.textContent;
        }
      }

      //Inset map - Map Section
      if ("nhs_PropertyMapImage" === event.target.id) {
        eventCategory = "Detail Page Events";
        eventAction = "Inset Map Navigation";
        eventLabel = "Clicks map to make interactive";
      }

      //View Builder Driving Directions
      if ("nhs_viewDrivingDirections" === event.target.id) {
        eventCategory = "Detail Page Events";
        eventAction = "Driving Directions Views";
        eventLabel = "Clicks to see driving directions";
      }

      //Route widget
      if ("object" === typeof event.target.dataset && event.target.dataset.showMapDirections) {
        eventCategory = "Detail Page Events";
        eventAction = "Routes Generated";
        eventLabel = "Route generated";
      }

      //Add Link for Commute Calculator
      if ("nhs_mapAddRoute" === event.target.id) {
        eventCategory = "Detail Page Events";
        eventAction = "Commute Calc Events";
        eventLabel = "Adds additional commute destination";
      }

      //Commute Calculator
      if ("nhs_calculateCommute" === event.target.id) {
        eventCategory = "Detail Page Events";
        eventAction = "Commute Calc Events";
        eventLabel = "Commute time generated";
        var travelModeElement = document.querySelector("[data-travel-mode].active");

        if (travelModeElement &&
          "object" === typeof travelModeElement.dataset &&
          travelModeElement.dataset.travelMode) {
          eventLabel += " - " + travelModeElement.dataset.travelMode.toLowerCase();
        } else { //By Default is driving
          eventLabel += " - driving";
        }
      }

      if (eventAction && eventLabel && id && window.ga) {
        ga(id + ".send", "event", eventCategory, eventAction, eventLabel);
      }
    });
  }

  var phone = document.querySelector("#TrackingPhoneNumber").value;
  var container = document.querySelector("#nhs_DetailSalesOffice [data-slider-component]") ||
    document.querySelector("[data-slider-component]");
  initDatePicker(container, phone, "/");
  initSaveToFavorites();
  bindGoogleAnalyticsEvents();

  var loadEmailSuggestions = function (event) {
    if (!window.Mailcheck && typeof NHS.loadJs === "function") {
      NHS.loadJs(document.getElementById("CtaDependencies").value);
    } else if (window.NewHomeSource && window.NewHomeSource.EmailDomainValidator) {
      window.NewHomeSource.EmailDomainValidator();
    }
    this.removeEventListener("focusin", loadEmailSuggestions);
  }

  function setPhoneRevealed(container, isRevealed) {
    if (!container) {
      return;
    }
    var hideElements = container.querySelectorAll('[data-phone-reveal-text]');
    var showElements = container.querySelectorAll('[data-phone-full-number]');
    hideElements.forEach(function (element) {
      element.hidden = isRevealed;
    });
    showElements.forEach(function (element) {
      element.hidden = !isRevealed;
    });
    if (isRevealed) {
      jQuery.SetDataLayerPair("sitePhoneNumV");
    }
  }

  function isPhoneRevealed(container) {
    var revealText = container && container.querySelector('[data-phone-reveal-text]');
    return !!(revealText && revealText.hasAttribute('hidden'));
  }

  function togglePhoneButton(toggle, isRevealed) {
    var showLabel = toggle.querySelector('[data-phone-toggle-show]');
    var hideLabel = toggle.querySelector('[data-phone-toggle-hide]');
    if (showLabel && hideLabel) {
      showLabel.hidden = isRevealed;
      hideLabel.hidden = !isRevealed;
    }
    toggle.setAttribute('aria-pressed', isRevealed ? 'true' : 'false');
  }

  function handlePhoneToggleCapture(event) {
    var toggle = event.target.closest('[data-phone-toggle]');
    if (!toggle) {
      return;
    }
    var container = toggle.closest('[data-phone-reveal-container]') || toggle.parentElement;
    var willReveal = !isPhoneRevealed(container);
    if (!willReveal) {
      // Prevent analytics/tracking listeners from firing on Hide clicks.
      event.stopPropagation();
    }
    setPhoneRevealed(container, willReveal);
    togglePhoneButton(toggle, willReveal);
  }

  function showPhone(event) {
    if (event.target.closest('[data-phone-toggle]')) {
      return;
    }
    var revealText = event.target.closest('[data-phone-reveal-text]');
    if (revealText) {
      var container = revealText.closest('[data-phone-reveal-container]') || revealText.parentElement;
      setPhoneRevealed(container, true);
      var toggle = container && container.querySelector('[data-phone-toggle]');
      if (toggle) {
        togglePhoneButton(toggle, true);
      }
    }
  }

  document.body.addEventListener('click', handlePhoneToggleCapture, true);
  document.body.addEventListener('click', showPhone);
  var onPageForm = document.querySelector("[data-onpage-form]");
  onPageForm.addEventListener("focusin", loadEmailSuggestions);
})();

(function () {
  /*
  *  This intersectionObserver is used to get the viewport of the sections of the details
  */
  var options = {
    rootMargin: '10px',
    threshold: 0.05
  }

  // Calculate the combined height of the sticky bar and main header to account for fixed elements at the top of the viewport.
  const getHeaderHeight = () => {
    const stickyBarEl = document.querySelector("[data-sticky-nav-bar]");
    const mainHeaderEl = document.querySelector("[data-main-header]");
    return (stickyBarEl ? stickyBarEl.getBoundingClientRect().height : 0) +
      (mainHeaderEl ? mainHeaderEl.getBoundingClientRect().height : 0);
  };
  const headerHeight = getHeaderHeight();
  let currentUserHeight = window.innerHeight;
  window.addEventListener("resize", () => {
    currentUserHeight = window.innerHeight;
  });

  var observerMainStickyBar = function () {
    var sectionDetails = document.querySelector("[data-details-container]");
    var sectionsToObserve = null;

    var observer = new IntersectionObserver(function (entries) {
      requestAnimationFrame(calculateSection);
    }, options);

    /**
     * calculateSection : method to check what is the section that is visible on the viewport to fix issues with scroll animation
     *
     */
    function calculateSection() {
      setTimeout(function () {
        var mainEntry = null;
        var closestDistance = Infinity;

        if (!sectionsToObserve || sectionsToObserve.length === 0) {
          return;
        }

        // Find the section whose top is nearest to the header threshold
        for (var j = 0; j < sectionsToObserve.length; j++) {
          var section = sectionsToObserve[j];
          var topSection = section.getBoundingClientRect().top;

          // Stop if this section is below the viewport
          if (topSection >= currentUserHeight) {
            break;
          }

          // Calculate distance from this section's top to the header threshold
          var distance = Math.abs(topSection - headerHeight);
          if (distance < closestDistance) {
            closestDistance = distance;
            mainEntry = section;
          } else if (topSection > headerHeight && distance > closestDistance) {
            // Distance is increasing after passing the header; stop searching
            break;
          }
        }
        if (mainEntry) {
          var stickyBar = document.querySelector("[data-sticky-nav-bar]");
          if (stickyBar) {
            var activeElement = stickyBar.querySelector("[data-item-active]");
            if (activeElement) {
              delete activeElement.dataset.itemActive;
              activeElement.classList.remove("nhs-n1-c-button--nav-light-active");
            }
            var entry = document.querySelector("a[data-id=\"" + mainEntry.id + "\"]");
            if (entry) {
              entry.dataset.itemActive = 'true';
              entry.classList.add("nhs-n1-c-button--nav-light-active");
              requestAnimationFrame(window.NewHomeSource.Modules.stickyBarScrollHandler.moveStickyBarScroll.bind(null, entry, '[data-scroll]'));
            }
          }
        }
      },
        200);
    }

    /*
     *  Track all sections that have an `id` applied
     */

    if (sectionDetails) {
      sectionsToObserve = sectionDetails.querySelectorAll("[data-detail-section]");
    }

    if (sectionsToObserve) {
      for (var sectionIndex = 0; sectionIndex < sectionsToObserve.length; sectionIndex++) {
        observer.observe(sectionsToObserve[sectionIndex]);
      }
    }
  }
  observerMainStickyBar();
})();